###

Provides sortable list functionality. List items can only be sorted vertically.

This functionality is less configurable than jQuery, but more reliable, and
works correctly with lists in parent elements whose height is greater than that
of the page.

###

angular.module('rjmNg.directives').directive 'sortableElement', [
  '$url'
  '$timeout'
  '$window'
  ($url, $timeout, $window) ->
    restrict: 'A'
    scope:

      # Only elements matching this selector can be used as the drag handle (the
      # element on which the user must click to start dragging).
      dragHandleSelector: "@"

      # A function to invoke when items are reordered. (The function should have
      # two arguments: newIndex and oldIndex.)
      sortHandler: "="

      # Whether sorting is enabled
      sortingEnabled: "="

      dragClass: '@'

      dragPlaceholderClass: '@'

      # Invoked when the user clicks on a drag handle, but before dragging
      # starts. If set, should return a boolean value indicating whether
      # dragging is allowed.
      dragStartClick: '&'

    link: (scope, element, attrs) ->

      parent = element.parent()

      # An element used to show the position that the element is being dragged
      # to.
      placeholder = null

      # The point (relative to the page) on which the user clicked.
      mouseDownPos = null

      # The distance between the the mouse down position and the position
      # (relative to the page) of the parent element.
      mouseDownOffset = null

      # Used for calculating the target position. Contains a list of y-values.
      # (See the getIndex() function.)
      indexBreakpoints = null

      # The initial index of the selected element in the list
      initialIndex = null

      # The index of the selected element in the list.
      currentIndex = null

      # Disable movement along the x-axis.
      disableX = true

      # The number of pixels from the top and bottom of the screen at which to
      # start scrolling.
      autoScrollThreshold = 10

      # The interval, while dragging, at which to check to see if the mouse is
      # within the scroll threshold and scroll accordingly.
      autoScrollPollInterval = 10 # milliseconds

      # The rate at which to auto-scroll.
      autoScrollRate = 20 # pixels / autoScrollPollInterval

      # Keeps track of the auto-scroll timer.
      autoScrollIntervalId = null

      # The (pageX, pageY) point of the last-fired drag event.
      lastPageY = null

      # Populate the indexBreakpoints array.
      calculateHeights = () ->
        heights = $.makeArray(parent.children().map () ->
          $(this).outerHeight()
        )

        indexBreakpoints = []
        totalHeight = 0

        for index in [0..heights.length-1]
          indexBreakpoints.push(totalHeight + heights[index] / 2)
          totalHeight += heights[index]

      # For some y value (within the parent element), determine the
      # corresponding index using the indexBreakpoints array.
      getIndex = (yPos) ->
        for breakpoint, index in indexBreakpoints
          if yPos < breakpoint
            return index

        return indexBreakpoints.length

      pixelMatcher = /^(\d+(?:\.\d*)?)px$/

      parsePixelStr = (pixelStr) ->
        if pixelStr? and (match = pixelStr.match(pixelMatcher))?
          return parseFloat(match[1])
        else
          return 0

      # Add a timer to the window to faciliate auto-scrolling. Whenever the
      # lastPageY value is within autoScrollThreshold pixels of the top or the
      # bottom of the window, gradually scroll up or down.
      addAutoScrollTimer = () ->
        # Only allow a single timer
        return if autoScrollIntervalId?

        # Clear this, to ensure we only scroll after the mouse has been
        # dragged.
        lastPageY = null

        autoScrollIntervalId = setInterval () ->
          return unless lastPageY?

          # The height of the viewport
          windowHeight = $($window).height()

          # The distance between the actual top of the page, and what is
          # displayed at the top of the window.
          scrollTop = $('body').scrollTop()
          maxScrollTop = $('body').height() - $($window).height()

          # The distance between the cursor and the top and bottom of the
          # window.
          distanceFromTop = lastPageY - scrollTop
          distanceToBottom = windowHeight - distanceFromTop

          if distanceToBottom <= autoScrollThreshold
            # Scroll down
            $('body').scrollTop Math.min(
              scrollTop + autoScrollRate
              maxScrollTop
            )

          else if distanceFromTop <= autoScrollThreshold
            # Scroll up.
            $('body').scrollTop Math.max(
              scrollTop - autoScrollRate
              0
            )

        , autoScrollPollInterval

      # Insert an item into the parent element at the specified index.
      insertOrAppendElement = (elementToInsert, index) ->
        if index < parent.children().length
          elementToInsert.insertBefore(parent.children().eq(index))
        else
          parent.append(elementToInsert)

      # Returns a string representation of an index.
      # 0 -> "1st", 1 -> "2nd", 2 -> "3rd", ....
      getPositionString = (index) ->
        number = index + 1
        if number is 1
          '1st'
        else if number is 2
          '2nd'
        else if number is 3
          '3rd'
        else
          number + 'th'

      # Drag start handler (event is a jQuery Event).
      dragStart = (event) ->
        # It should only be possible to initiate a drag event with the left
        # mouse button.
        return unless event.which is 1

        # Sanity check. Multiple placeholders is bad.
        return if placeholder?

        if scope.dragStartClick? and not scope.dragStartClick()
          return

        # If we click and drag, the default behavior is to select the
        # surrounding text. Prevent this from happening.
        event.preventDefault()

        # Create the placeholder element
        placeholder = $(document.createElement('div'))
        height = element.height()
        height += parsePixelStr element.css('borderTopWidth')
        height += parsePixelStr element.css('borderBottomWidth')
        placeholder.css('height', height + 'px')
        placeholder.css('width', element.width() + 'px')

        if scope.dragPlaceholderClass?
          placeholder.addClass(scope.dragPlaceholderClass)

        dragPosition = $(document.createElement('p'))
        dragPosition.addClass('drag-position')
        placeholder.append(dragPosition)

        # placeholder.css('background', 'red')
        placeholder.insertBefore(element)

        # Position the item being dragged absolutely, so we can render it
        # wherever the cursor is dragged.
        element.css('position', 'absolute')
        element.css('width', placeholder.width())
        if scope.dragClass?
          element.addClass(scope.dragClass)
        element.offset($(placeholder).offset())

        # Remove the element.
        element.remove()

        # Calculate the heights of all elements, using the placeholder as a
        # surrogate for this element
        calculateHeights()

        # Insert it at the end of the parent DOM so it doesn't affect our
        # indices.
        parent.append(element)

        yPos = $(placeholder).offset().top - $(parent).offset().top
        currentIndex = initialIndex = getIndex(yPos)

        dragPosition.text(getPositionString(currentIndex))

        mouseDownPos =
          left: event.pageX
          top: event.pageY

        mouseDownOffset = element.offset()

        # Add listeners to the window for when the mouse is moved. These have to
        # be attached to the window, because window is the only event target
        # which allows elements to be dragged beyond its bound and still fires a
        # mouseup event when the mouse is released.
        $($window).on 'mouseup', dragEnd
        $($window).on 'mousemove', dragMove

        addAutoScrollTimer()

      # Drag move handler (event is a jQuery Event).
      dragMove = (event) ->

        mouseDelta =
          left: if disableX then 0 else event.pageX - mouseDownPos.left
          top: event.pageY - mouseDownPos.top

        # Prevent the element currently being dragged from being dragged above
        # the top of the parent element.
        minTop = Math.max(
          mouseDownOffset.top + mouseDelta.top
          parent.offset().top
        )

        offset =
          left: mouseDownOffset.left + mouseDelta.left
          top: minTop

        element.offset(offset)

        yPos = offset.top - $(parent).offset().top
        newIndex = getIndex(yPos)

        if newIndex isnt currentIndex
          placeholder.remove()
          insertOrAppendElement(placeholder, newIndex)
          currentIndex = newIndex

          placeholder.find('.drag-position').text(
            getPositionString(currentIndex)
          )

        lastPageY = event.pageY

      # Drag end handler.
      dragEnd = () ->
        # Remove the placeholder.
        if placeholder?
          placeholder.remove()
          placeholder = null

        # Clear the auto-scroll timer.
        if autoScrollIntervalId?
          clearInterval(autoScrollIntervalId)
          autoScrollIntervalId = null

        if initialIndex?
          # Restore static positioning for the element.
          element.css('position', 'static')
          if scope.dragClass?
            element.removeClass(scope.dragClass)

          # Move the element to the correct position
          element.remove()
          insertOrAppendElement(element, currentIndex)

          # The drag handler seems to be removed from the element when it's
          # removed from the DOM, so restore it.
          addDragHandler()

          # Invoke the handler
          if scope.sortHandler?
            scope.sortHandler(currentIndex, initialIndex)

          currentIndex = initialIndex = null

        # Remove the mouse events from the window.
        $($window).off 'mouseup', dragEnd
        $($window).off 'mousemove', dragMove

      addDragHandler = () ->
        element.find(scope.dragHandleSelector).on 'mousedown', dragStart

      scope.$watch 'sortingEnabled', (newValue, oldValue) ->

        if newValue and not oldValue
          addDragHandler()
        else if oldValue and not newValue
          # Restore the original position of the element
          currentIndex = initialIndex

          # Remove handlers and timer and restore original positioning
          dragEnd()

          # Remove the drag handler
          element.find(scope.dragHandleSelector).off 'mousedown', dragStart

      if scope.sortingEnabled
        addDragHandler()

]
